import { HelperService } from "src/app/services/core/helper.service";


export namespace InvestorModel {
  export class InvestorVM {
    InvestorId: number;
  }
  export class GetInvestorFolioListOM {
    folioList: InvestorFolioData[] | null;
    lastTransactFolioNo: string | null;
  }

  export class BankMandateConfigVM {
    refKey: string;
    contextMenuCode: string;
    investorId: number;
    panNumber: string
  }

  export class MandateFormVM {
    refKey: string;
    investorId: number;
    rowId: number;
  }

  export class UploadMandateVM {
    RowId: number;
    MandateId: string;
    file: File;
  }

  export class BankListForPaymentVM {
    refKey: string;
    investorId: number;
  }

  export class InvestorFolioData {
    folioNo: string;
    mfInvestmentAccId: string;
    folioName: string;
    holdingPattern: string;
    taxStatus: string;
    marketValue: number | null;
    holdings: Array<InvestorModel.SchemeHoldingData> | null;
  }
  export class SchemeHoldingData {
    schemeName: string;
    isin: string;
    marketValue: number | null; //total amount
    asOnDate: string;
    holdings: number | null;  //total unit
    availableUnits: number | null; //available unit
    availableValue: number | null; //available amount
    ltcg: number | null; //available amount
    stcg: number | null; //available amount
  }

  export class FolioTypeVM {
    folioList: FolioDetail[] = [];
    lastTransactFolioNo: string;
    selectedFolio: FolioDetail = null;
    constructor() { }
    public static resolve(item: any): FolioTypeVM {
      let folioInfo = new FolioTypeVM();
      if (item.folioList && item.folioList.length > 0) {
        for (let i = 0; i < item.folioList.length; i++) {
          const info2 = FolioDetail.resolve(item.folioList[i], item.lastTransactFolioNo);
          if (info2.isSelected == true && info2.isLastTransact == true) {
            folioInfo.selectedFolio = info2;
          }
          folioInfo.folioList.push(info2);
        }
      }
      folioInfo.lastTransactFolioNo = item.lastTransactFolioNo;
      return folioInfo;
    }
  }

  export class FolioDetail {
    folioNo: string;
    folioName: string;
    holdingPattern: string;
    taxStatus: string;
    marketValue: string;
    marketValueText: string;
    isLastTransact: boolean;
    isSelected: boolean;
    holdings: FolioHoldingDetail[] = [];
    mfInvestmentAccId: string;
    constructor() { }

    public static resolve(item: any, lastTransactFolioNo: string): FolioDetail {
      const folioDetail = new FolioDetail();
      folioDetail.folioNo = item.folioNo;
      folioDetail.folioName = item.folioName || 'folio name';
      folioDetail.holdingPattern = item.holdingPattern != null ? item.holdingPattern.charAt(0).toUpperCase() + item.holdingPattern.slice(1).toLowerCase() : '';
      folioDetail.taxStatus = item.taxStatus || '-';
      folioDetail.marketValue = item.marketValue;
      folioDetail.marketValueText = (item.marketValue != null) ? HelperService.ToIndianCurrencyString(parseInt(item.marketValue), true) : '-';
      folioDetail.isSelected = false;
      folioDetail.isLastTransact = false;
      folioDetail.mfInvestmentAccId = item.mfInvestmentAccId;
      if (item.folioNo == lastTransactFolioNo) {
        folioDetail.isSelected = true;
        folioDetail.isLastTransact = true;
      }
      if (item.holdings && item.holdings.length > 0) {
        for (let i = 0; i < item.holdings.length; i++) {
          const info2 = FolioHoldingDetail.resolve(item.holdings[i]);
          folioDetail.holdings.push(info2);
        }
      }
      else {
        folioDetail.holdings = null;
      }
      return folioDetail;
    }
  }
  export class FolioHoldingDetail {
    schemeName: string;
    marketValue: number;
    marketValueText: string;
    asOnDate: string;
    isin: string;
    constructor() { }
    public static resolve(item: any): FolioHoldingDetail {
      const folioHoldingDetail = new FolioHoldingDetail();
      folioHoldingDetail.schemeName = item.schemeName;
      folioHoldingDetail.marketValue = item.marketValue;
      folioHoldingDetail.marketValueText = (item.marketValue != null) ? HelperService.ToIndianCurrencyString(item.marketValue, true) : '-';;
      folioHoldingDetail.asOnDate = item.asOnDate;
      folioHoldingDetail.isin = item.isin;

      return folioHoldingDetail;
    }
  }

  export class BankAccountOM {
    investorbBankId: string;
    bankName: string;
    accHolderName: string;
    accNumber: string;
    accType: string;
    ifscCode: string;
  }

  export class BankMandateOM {
    id: number;
    bankAccountId: number;
    mandateRef: string;
    mandateToken: string;
    validFrom: string | null;
    validFromFormatted: string | null;
    validTo: string | null;
    validToFormatted: string | null;
    mandateLimit: number;
    mandateType: string;
    mandateStatus: string;
    umrn: string;
    bankName: string;
    accNumber: string;
    accType: string;
  }

  export class PayoutDetailsDataOM {
    schemeCode: string;
    bankName: string;
    accountNumber: string;
    accountType: string;
    ifsc: string;
  }

  export class MfPortfolioDataOM {
    Records: PortfolioRecords[] = [];
    Total: PortfolioTotal[] = [];
    GroupData: PortfolioGroupData[] = [];
    GroupOrder: PortfolioGroupOrder[] = [];
    constructor(obj: any) {
      this.Records = obj.Records;
      this.Total = obj.Total;
      this.GroupData = obj.GroupData;
      this.GroupOrder = obj.GroupOrder;
    }
  }

  export class CategoryListOM {
    Data: CategoryList[];
    constructor(obj: CategoryList[]) {
      this.Data = obj;
    }
  }

  export class RecommendationListOM {
    Data: RecommendationList[];
    constructor(obj: RecommendationList[]) {
      this.Data = obj;
    }
  }

  export class RecommendationList {
    AMCID: number;
    SchCode: number;
    BseTokenNo: number;
    BSESchCode: string;
    SchemeName: string;
    ISIN: string;
    NatureDes: string;
    Category: string;
    RecCategoryCode: number;
    Remarks: string;
    FP: boolean;
    SIP: boolean;
    Weightage: number;
    Return1Day: number;
    Return1Week: number;
    Return2Week: number;
    Return1Month: number;
    Return3Month: number;
    Return6Month: number;
    Return9Month: number;
    Return1Year: number;
    Return2Year: number;
    Return3Year: number;
    Return5Year: number;
    ABSRetn: number;
    Corpus: number;
  }

  export class RecommendationListVM {
    recommendationId: number;
  }
  export class CategoryList {
    CategoryCode: number;
    CategoryName: string;
    isDefault: boolean;
    Return1D: boolean;
    Return1W: boolean;
    Return2W: boolean;
    Return1M: boolean;
    Return3M: boolean;
    Return6M: boolean;
    Return9M: boolean;
    Return1Y: boolean;
    Return2Y: boolean;
    Return3Y: boolean;
    Return5Y: boolean;
    IsRemarks: boolean;
    Corpus: boolean;
    Text: string;
    Id: number;
  }

  export interface PortfolioTotal {
    AbsRetn: number;
    AnnualizedRetn: number;
    BenchmarkReturn: number;
    CurrentValue: number;
    DivPayout: number;
    GrossAmount: number;
    InvestedAmount: number;
    NotionalPL: number;
    StampDuty: string;
    Total: string;
    Weightage: number;
    XIRR: number;
  }

  export class PortfolioRecords {
    AbsRetn: number;
    AnnualizedRetn: number;
    AvgCost: number;
    BUnits: number;
    BenchmarkReturn: number;
    Category: string;
    CurrentNAV: number;
    CurrentValue: number;
    DPID: string;
    DivFlag: string;
    DivPayout: number;
    FolioNo: string;
    GoalID: string;
    GoalName: string;
    GrossAmount: number;
    InvCode: string;
    InvestedAmount: number;
    InvestorCode: string;
    InvestorID: number;
    InvestorName: string;
    NAVDate: string;
    NAVDateText: string;
    Nature: string;
    NotionalPL: number;
    SchCode: number;
    SchemeName: string;
    StampDuty: number;
    SubNature: string;
    TaxStatus: string;
    Weightage: number;
    XIRR: number;
    Text: string;
    Id: string;
  }

  export class PortfolioGroupData {
    GroupOn: string;
    GroupItem: string;
    SchemeName: string;
    InvestedAmount: number;
    CurrentValue: number;
    DivPayout: number;
    NotionalPL: number;
    AbsRetn: number;
    AnnualizedRetn: number;
    XIRR: number;
    BenchmarkReturn: number;
    Weightage: number;
    GrossAmount: number;
    StampDuty: number;
  }


  export class PortfolioGroupOrder {
    GroupOn: string;
    BgColor: string;
  }

  export class SipBookReportInputVM {
    ReportType: string;
    InvestorId: number;
    FromDate: string;
    ToDate: string;
  }

  export class SipReportListOM {
    Data: SipReportList[];
    constructor(obj: SipReportList[]) {
      this.Data = obj;
    }
  }

  export class SipReportList {
    InvestorCode: string;
    InvestorName: string;
    AMCID: number;
    SchemeName: string;
    FolioNo: string;
    FromDate: string;
    FromDateText: string;
    ToDate: string;
    ToDateText: string;
    SIPDay: string;
    Amount: number;
    Frequency: string;
    Registrationdate: string;
    RegistrationdateText: string;
    MandateID: string;
    MandateStatus: string;
    RegNo: string;
    SubBrokerCode: string;
    SubBrokerName: string;
    EmpCode: string;
    EmployeeName: string;
    BranchCode: string;
    BranchName: string;
    ZoneCode: string;
    ZoneName: string;
    RegionCode: string;
    RegionName: string;
    OrderID: number;
    StopSipRequest: boolean;
    Status: string;
    BankName: string;
    BankBranch: string;
    AccountNumber: string;
    MandateType: string;
  }

  export class RegisteredSTPReportVM {
    ReportType: string;
    InvestorId: number;
    FromDate: string;
    ToDate: string;
  }

  export class StpReportListOM {
    Data: StpReportList[];
    constructor(obj: StpReportList[]) {
      this.Data = obj;
    }
  }

  export class StpReportList {
    InvestorCode: string;
    InvestorName: string;
    AMCID: number;
    SchemeName: string;
    FolioNo: string;
    FromDate: string;
    FromDateText: string;
    ToDate: string;
    ToDateText: string;
    STPDay: string;
    Amount: number;
    Frequency: string;
    Registrationdate: string;
    RegistrationdateText: string;
    RegNo: string;
    SubBrokerCode: string;
    SubBrokerName: string;
    EmpCode: string;
    EmployeeName: string;
    BranchCode: string;
    BranchName: string;
    ZoneCode: string;
    ZoneName: string;
    RegionCode: string;
    RegionName: string;
    OrderID: number;
    Status: string;
    TargetScheme: string;
  }

  export class RegisteredSWPReportVM {
    ReportType: string;
    InvestorId: number;
    FromDate: string;
    ToDate: string;
  }

  export class SwpReportListOM {
    Data: SwpReportList[];
    constructor(obj: SwpReportList[]) {
      this.Data = obj;
    }
  }

  export class SwpReportList {
    InvestorCode: string;
    InvestorName: string;
    AMCID: number;
    SchemeName: string;
    FolioNo: string;
    FromDate: string;
    FromDateText: string;
    ToDate: string;
    ToDateText: string;
    SWPDay: string;
    Amount: number;
    Frequency: string;
    Registrationdate: string;
    RegistrationdateText: string;
    RegNo: string;
    SubBrokerCode: string;
    SubBrokerName: string;
    EmpCode: string;
    EmployeeName: string;
    BranchCode: string;
    BranchName: string;
    ZoneCode: string;
    ZoneName: string;
    RegionCode: string;
    RegionName: string;
    OrderID: number;
    Status: string;
  }

  export class MfPortfolioReportVM2 {
    InvestorItemType: string;
    InvestorItemId: number;
    ArnNumber: string;
    AsOnDate: string;
  }

  export class InvestorPanOnlyIM {
    Pan: String;
  }

  export class InvestmentAccountOM {
    List: InvestmentAccount[];
  }
  class InvestmentAccount {
    inv_acc_id: string;
    inv_id: number;
    primary_pan: string;
    second_pan: string;
    third_pan: string;
    primary_inv_id: number;
    second_inv_id: number;
    third_inv_id: number;
    holding_pattern: string;
    created_at: string;
  }

  export class InvestorFolioDetailsIM {
    folio_Number: string;
    mf_Investment_Account_Id: string;
  }

  export class InvestorFolioDetailsOM {
    folio_no: string;
    mobile: string;
    email: string;
    holders: Holder[];
    nominee: Nominee[];
    bank: Bank[];
  }

  class Bank {
    bank_name: string;
    acc_number: string;
    acc_type: string;
    ifsc: string;
    branch: string;
  }

  class Holder {
    caption: string;
    name: string;
    pan: string;
    dob: string;
    tax_status: string;
    kyc_status: string;
    holding_mode: string;
    nationality: string;
    fatca_flag: string;
    phone_resi: string;
    phone_office: string;
    address: string;
  }

  class Nominee {
    name: string;
    tax_status: string;
    dob: string;
    pan: string;
    per_alloc: string;
    relation: string;
    is_minor: boolean;
    guradian_name: string;
    guradian_pan: string;
    guradian_dob: string;
    guradian_relation: string;
  }

  export class MFAllocationVM {
    ArnNumber: null;
    AsOnDate: string;
    InvestorItemId: number;
    InvestorItemType: string;
  }

  export class MFAllocationOM {
    Data: MFAllocation;
    constructor(obj: MFAllocation) {
      this.Data = obj;
    }
  }

  export class MFAllocation {
    AMCWise: AMCWiseRecord[] = [];
    CategoryWise: CategoryWiseRecord[] = [];
    CompanyWise: CompanyWiseRecord[] = [];
    SchemeWise: SchemeWiseRecord[] = [];
    IndustryWise: IndustryWise[] = [];
    constructor(obj: any) {
      this.AMCWise = obj.AMCWise;
      this.CategoryWise = obj.CategoryWise;
      this.CompanyWise = obj.CompanyWise;
      this.SchemeWise = obj.SchemeWise;
      this.IndustryWise = obj.IndustryWise;
    }
  }

  export class AMCWiseRecord {
    AMCName: string;
    Allocation: number;
    Perc: number;
  }

  export class CategoryWiseRecord {
    Allocation: number;
    Category: string;
    Perc: number;
  }

  export class CompanyWiseRecord {
    Allocation: number;
    CompanyName: string;
    Perc: number;
  }

  export class SchemeWiseRecord {
    Allocation: number;
    SchemeName: string;
    Perc: number;
  }

  export class IndustryWise {
    Allocation: number;
    Industry: string;
    Perc: number;
  }

  export class MfPerformanceDataOM {
    Records: PerformanceRecords[] = [];
    Total: PerformanceTotal[] = [];
    GroupData: PerformanceGroupData[] = [];
    GroupOrder: PerformanceGroupOrder[] = [];
    constructor(obj: any) {
      this.Records = obj.Records;
      this.Total = obj.Total;
      this.GroupData = obj.GroupData;
      this.GroupOrder = obj.GroupOrder;
    }
  }

  export class PerformanceRecords {
    InvestorCode: string;
    InvestorName: string;
    FolioNo: string;
    SchCode: number;
    SchemeName: string;
    Category: string;
    OpeningValue: number;
    Inflow: number;
    OutFlow: number;
    BookedPL: number;
    NotionalPL: number;
    ClosingValue: number;
    AbsRetn: number;
    AnnualizedRetn: number;
    XIRR: number;
    BenchmarkReturn: number;
    Weightage: number;
  }

  export class PerformanceGroupData {
    GroupOn: string;
    GroupItem: string;
    Category: string;
    OpeningValue: number;
    Inflow: number;
    OutFlow: number;
    BookedPL: number;
    NotionalPL: number;
    ClosingValue: number;
    AbsRetn: number;
    AnnualizedRetn: number;
    XIRR: number;
    BenchmarkReturn: number;
    Weightage: number;
  }

  export class PerformanceGroupOrder {
    GroupOn: string;
    BgColor: string;
  }

  export class PerformanceTotal {
    Total: string;
    OpeningValue: number;
    Inflow: number;
    OutFlow: number;
    BookedPL: number;
    NotionalPL: number;
    ClosingValue: number;
    AbsRetn: number;
    AnnualizedRetn: number;
    XIRR: number;
    BenchmarkReturn: number;
    Weightage: number;
  }

  export class TransactionReportListOM {
    Data: TransactionReportList[];
    constructor(obj: TransactionReportList[]) {
      this.Data = obj;
    }
  }

  export class TransactionReportList {
    BrokerName: string;
    InvestorCode: string;
    InvestorName: string;
    SubBrokerCode: string;
    SubBrokerName: string;
    EmpCode: string;
    EmployeeName: string;
    BranchCode: string;
    BranchName: string;
    ZoneCode: string;
    ZoneName: string;
    RegionCode: string;
    RegionName: string;
    NavDate: string;
    NavDateText: string;
    TranDate: string;
    TranDateText: string;
    SchemeName: string;
    FolioNo: string;
    TranType: string;
    SubTranType: string;
    Amount: number;
    Rate: number;
    Units: number;
    RevTag: string;
    ReversalReason: string;
    StampDuty: number;
    TDS: number;
  }

  export class GainLossReportListOM {
    Table2: any[] = [];
    Table3: any[] = [];
    data: GainLossData[] = [];

    constructor(obj: any) {
      this.Table2 = obj.Table2;
      this.Table3 = obj.Table3;
      this.data = obj.data;
    }
  }

  export class GainLossData {
    InvestorCode: string;
    InvestorName: string;
    SchCode: string;
    SchemeName: string;
    Nature: string;
    FolioNo: string;
    PTrxnType: string;
    PTranDate: string;
    PUnits: number;
    PRate: number;
    PAmount: number;
    STrxnType: string;
    STranDate: string;
    SUnits: number;
    SRate: number;
    SAmount: number;
    nDays: number;
    STT: number;
    ValueAsOn31012018: number;
    NAVAsOn31012018: number;
    ISIN: string;
    EquityGLST: number;
    NonEquityGLST: number;
    EquityGLLT: number;
    NonEquityGLLT: number;
    ShortTermGL: number;
    LongTermGL: number;
    Description: string;
    ReturnPerc: number;
    TDS: number;
    StampDuty: number;
    AnnRetn: number;
  }

  export class DashCollectionReportVM {
    FromDate: string;
    ToDate: string;
    RefKey: string;
  }

  export class DashCollectionReportOM {
    Data: DashCollectionReport[];
    constructor(obj: DashCollectionReport[]) {
      this.Data = obj;
    }
  }

  export class DashCollectionReport {
    AMC_Name: string;
    Purchase_Count: number;
    Purchase_Amount: number;
    Redemption_Count: number;
    Redemption_Amount: number;
    Net_Count: number;
    Net_Amount: number;
  }

  export class DashTable1 {
    CompletedOrder: number;
    RejectedOrder: number;
    PendingOrder: number;
    MFCompleted: number;
    FDCompleted: number;
    NCDCompleted: number;
    MFRejected: number;
    FDRejected: number;
    NCDRejected: number;
    MFPending: number;
    FDPending: number;
    NCDPending: number
  }

  export class ActiveBankListOM {
    Data: ActiveBankList[];
    constructor(obj: ActiveBankList[]) {
      this.Data = obj;
    }
  }

  export class ActiveBankList {
    Id: number;
    BankName: string;
    BankBranch: string;
    AccountNumber: string;
    IfscCode: string;
    MicrCode: string;
    City: string;
    State: string;
    BankId: number;
    IsDefaultBank: boolean;
    BankIconId: number;
    IsDefault: string;
    HasUCC: boolean;
    ENachAllowed: boolean;
  }

  export class ChangePasswordVM {
    OldPassword: string;
    NewPassword: string;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class MandateListOM {
    Data: MandateList[];
    constructor(obj: MandateList[]) {
      this.Data = obj;
    }
  }

  export class MandateList {
    MandateId: string;
    AccountNumber: string;
    BankName: string;
    MandateLimit: string;
    DateFromText: string;
    DateToText: string;
    Status: string;
  }

  export class AddBankAccountVM {
    InvestorId: number;
    BankId: number;
    BankName: string;
    AccountTypeId: number;
    AccountNumber: string;
    BranchName: string;
    IfscCode: string;
    MicrCode: string;
    NameAsPerBank: string;
  }
  export class AddBankMandateVM {
    InvestorId: number;
    InvestorBankRowId: number;
    AccountNumber: string;
    MandateLimit: number;
    MandateTypeId: string;
    MandateFromDate: string;
    MandateToDate: string;
  }

  export class PurOrderSchemeDataVM {
    SchemeCode: number;
    DividendFlag: string;
    RefKey: string
  }

  export class PurOrderSchemeDataOM {
    Data: PurOrderSchemeData[];
    constructor(obj: PurOrderSchemeData[]) {
      this.Data = obj;
    }
  }

  export class PurOrderSchemeData {
    SchemeCode: string;
    SchemeName: string;
    BSETokenNo: number;
    SchCode: number;
    SchParentCode: string;
    AmcId: number;
    AMCName: string;
    DivReFlag: string;
    ISIN: string;
    Category: string;
    Risk: string;
    LatestNAV: string;
    NAVDate: string;
    NAVChange: number;
  }

  export class PurchaseOrderVM {
    SchCode: string;
    SchemeName: string;
    SchemeToken: string;
    FolioNo: string;
    Amount: string;
    ChequeNumber: string;
    TranMode: string;
    BasketCode: string;
    GoalId: string;
    InvestorId: number;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class Order2faInfo {
    refKey: string;
    investorId: number;
    gwsOrderId: number;
    tranType: string;
  }

  export class Order2faSendOTP {
    refKey: string;
    investorId: number;
    gwsOrderId: number;
    tranType: string;
  }

  export class Order2faVerifyOTP {
    refKey: string;
    investorId: number;
    gwsOrderId: number;
    tranType: string;
    holderSeq: number;
    otpKey: string;
    otpValue: string;
  }

  export class SipOrderSchemeInfoVM {
    BseSchemeCode: string;
    RefKey: string;
  }

  export class sipOrderSchemeInfoOM {
    Data: Data;
    constructor(obj1: Data) {
      this.Data = obj1;
    }
  }

  export class Data {
    SchemeInfo1: SchemeInfo1;
    SchemeInfo2: SchemeInfo2;
    constructor(obj1: SchemeInfo1, obj2: SchemeInfo2) {
      this.SchemeInfo1;
      this.SchemeInfo2;
    }
  }

  export class SchemeInfo1 {
    AMCID: number;
    AMCName: string;
    ISIN: string;
    SchemeCode: string;
    SchemeName: string;
    BSEToken: string;
    LatestNAV: number;
    NAVDate: string;
    NAVChange: number;
    Risk: string;
    Category: string;
    SchCode: number;
    Objective: string;
    TranMode: string;
  }

  export class SchemeInfo2 {
    AMCID: number;
    AMCName: string;
    ISIN: string;
    SchemeCode: string;
    SchemeName: string;
    SIPFrequency: string;
    SIPDates: string;
    SIPMinGAP: number;
    SIPMaxGAP: number;
    SIPMinInstallmentAmount: number;
    SIPMinInstallmentNo: number;
    SIPMultiplierAmt: number;
    SIPMaxInstallmentAmount: number;
    SIPMaxInstallmentNo: number;
  }

  export class SipOrderVM {
    InvestorId: number;
    SchCode: number;
    SchemeName: string;
    SchemeToken: string;
    FolioNo: string;
    Amount: string;
    Frequency: string;
    SipStartDate: string;
    NoOfInstallments: string;
    BankMandateId: string;
    IsFirstOrderToday: boolean;
    ChequeNumber: string;
    TranMode: string;
    BasketCode: string;
    GoalId: string;
    EnhancedSipType: string;
    EnhancedSipSwitchSchemeCode: string;
    EnhancedSipSwitchAmount: number;
    EnhancedSipSwitchBSESchemeToken: string;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class ReedemOrderVM {
    InvestorId: number;
    SchCode: string;
    SchemeToken: string;
    FolioNo: string;
    FolioTranMode: string;
    RedemptionIn: string;
    RedemptionValue: string;
    BankAccountNo: string;
    RefKey: string;
    ContextMenuCode: string
  }

  export class TransactionDetailsVM {
    FolioNo: string;
    SchemeCode: number;
    AsOnDate: string;
  }

  export class TransactionDetailsOM {
    Data: TransactionDetailsData;
    constructor(obj1: TransactionDetailsData) {
      this.Data = obj1;
    }
  }

  export class TransactionDetailsData {
    Table: Table;
    Table1: Table1;
    constructor(obj1: Table, obj2: Table1) {
      this.Table;
      this.Table1;
    }
  }

  export class AUMReportVM {
    ReportType: string;
    AsOnDate: string;
    ArnNumber: string;
    AmcId: number;
    SchCode: number;
    CategoryCode: number;
    RefKey: string;
  }

  export class AUMReportOM {
    Data: AUMReport;
    constructor(obj1: AUMReport) {
      this.Data = obj1;
    }
  }

  export class AUMReport {
    Table: AUMTable[];
    Table1: AUMTable1[];
    constructor(obj1: Table, obj2: Table1) {
      this.Table;
      this.Table1;
    }
  }

  export class AUMTable {
    CategoryCode: number;
    Category: string;
    Total_AUM: number;
    Region_Code: string;
    Region_Name: string;
    Equity: number;
    Debt: number;
    Liquid: number;
    Other: number;
    Zone_Code: string;
    Zone_Name: string;
    Branch_Code: string;
    Branch_Name: string;
    Emp_Code: string;
    Employee_Name: string;
    Sub_Broker_Code: string;
    Sub_Broker_Name: string;
    InvestorCode: number;
    Investor_Name: string;
    SubBrokerCode: string;
    SubBrokerName: string;
    EmpCode: string;
    EmployeeName: string;
    BranchCode: string;
    BranchName: string;
    ZoneCode: string;
    ZoneName: string;
    RegionCode: string;
    RegionName: string;
    AMCID: number;
    AMC_Name: string;
    Scheme_Name: string;
    InvGroupName: string;
    Folio_No: string;
    ProdCode: string;
    AMCName: string;
    InvGroupCode: number;
    Investor_Group_Name: string;
  }

  export class AUMTable1 {
    Total: string;
    Total_AUM: number;
    Equity: number;
    Debt: number;
    Liquid: number;
    Other: number;
  }

  export class CollectionReportVM {
    ReportType: string;
    arnNumber: string;
    AmcId: number;
    SchCode: number;
    CategoryCode: number;
    FromDate: string;
    ToDate: string;
    RefKey: string;
  }

  export class CollectionReportOM {
    Data: CollectionReport[];
    constructor(obj: CollectionReport[]) {
      this.Data = obj;
    }
  }

  export class CollectionReport {
    Category: string;
    Purchase_Count: number;
    Purchase_Amount: number;
    Redemption_Count: number;
    Redemption_Amount: number;
    Net_Count: number;
    Net_Amount: number;
    Region_Code: number;
    Region_Name: string;
    Zone_Code: string;
    Zone_Name: string;
    BranchCode: string;
    Branch_Name: string;
    EmpCode: string;
    Employee_Name: string;
    SubBrokerCode: string;
    SubBroker_Name: string;
    Investor_Name: string;
    PAN: string;
    AMC_Name: string;
    Scheme_Name: string;
    Sub_Category: string;
    Investor_Code: string;
    InvGroupName: string;
    SubBrokerName: string;
    InvGroupCode: number;
  }

  export class Table {
    InvestorCode: string;
    InvestorName: string;
    FolioNo: string;
    SchemeName: string;
    NAVDate: string;
    NAVDateText: string;
    NAV: number;
    BalanceUnits: number;
    StampDuty: number;
  }

  export class Table1 {
    PID: number;
    InvestorCode: string;
    InvestorName: string;
    FolioNo: string;
    SchemeName: string;
    NAVDate: string;
    NAVDateText: string;
    CurrentNAV: number;
    TranDate: string;
    TranDateText: string;
    TranType: string;
    Amount: number;
    InvestedAmount: number;
    Units: number;
    BalUnits: number;
    DivPayout: number;
    NAV: number;
    HoldingPeriod: number;
    CurrentValue: number;
    NotionalPL: number;
    AbsRetn: number;
    AnnualizedRetn: number;
    XIRR: number;
    DaysToLongTerm: number;
    ExitloadIndication: string;
    BenchmarkReturn: number;
    StampDuty: number;
  }

  export class InvestorAMCFoliosVM {
    AmcId: number;
    TranMode: string;
    InvestorId: number;
    RefKey: string;
  }

  export class InvestorAMCFoliosOM {
    Data: InvestorAMCFolio[];
    constructor(obj: InvestorAMCFolio[]) {
      this.Data = obj;
    }
  }

  export class InvestorAMCFolio {
    FolioNo: string;
    TranMode: string;
    TaxStatus: string
  }

  export class NewFormVM {
    InvestorId: number;
    RefKey: string;
  }

  export class NewFormOM {
    Data: NewForm[];
    constructor(obj: NewForm[]) {
      this.Data = obj;
    }
  }

  export class NewForm {
    InvestorId: number;
    InvestorCode: string;
    InvestorName: string;
    PAN: string;
    Mobile: string;
    Email: string;
    GuardianName: string | null;
    DOB: string;
    DobText: string;
    Gender: string;
    GenderText: string;
    IsMinor: boolean;
    HoldingPattern: string;
    SecondHolderName: string | null;
    SecondHolderPAN: string | null;
    ThirdHolderName: string | null;
    ThirdHolderPAN: string | null;
    IsKyced: boolean;
    HasUCC: boolean;
    UccRequired: boolean;
    HasFatca: boolean;
    FatcaRequired: boolean;
    TiffFlag: boolean;
    TiffRequired: boolean;
    Depository: string;
    DPID: string | null;
    TaxStatusID: number;
    DPID2: string | null;
  }

  export class SchemeListForSwitchVM {
    FolioTranMode: string;
    SchemeCode: string;
    RefKey: string;
  }

  export class SchemeListForSwitchOM {
    Data: SchemeListForSwitch[];
    constructor(obj: SchemeListForSwitch[]) {
      this.Data = obj;
    }
  }

  export class SchemeListForSwitch {
    SchemeCode: string;
    SchemeName: string;
  }

  export class SwitchOrderVM {
    InvestorId: number;
    SwitchFromSchCode: number;
    SwitchToSchCode: number;
    SwitchFromBseSchemeToken: string;
    SwitchToBseSchemeToken: string;
    SwitchFromFolioNo: string;
    SwitchToFolioNo: string;
    FolioTranMode: string;
    SwitchIn: string;
    SwitchValue: number;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class InititateInvestorFullUCCVM {
    refKey: string;
    investorId: number;
    panNumber: string;
  }

  export class SwitchOrderSchemeDetailVM {
    BseSchemeCode: string;
    RefKey: string;
  }

  export class SwitchOrderSchemeDetailOM {
    Data: SwitchSchemeDetail[];
    constructor(obj: SwitchSchemeDetail[]) {
      this.Data = obj;
    }
  }

  export class SwitchSchemeDetail {
    Table: SwitchSchemeDetailTable;
    constructor(obj1: SwitchSchemeDetailTable) {
      this.Table;
    }
  }

  export class SwitchSchemeDetailTable {
    AMCID: number;
    AMCName: string;
    ISIN: string;
    SchemeCode: string;
    SchemeName: string;
    BSEToken: string;
    DivReFlag: string;
    LatestNAV: string;
    NAVDate: string;
    NAVChange: number;
    Risk: string;
    Category: string;
    SchCode: number;
    SchParentCode: number;
    MinPurAmt: number;
    PurAmountMult: number;
    Objective: string;
    TranMode: string;
  }

  export class StpOrderVM {
    InvestorId: number;
    SwitchFromSchCode: number;
    SwitchToSchCode: number;
    SwitchFromBseSchemeToken: string;
    SwitchToBseSchemeToken: string;
    SwitchFromFolioNo: string;
    FolioTranMode: string;
    InstallmentAmount: string;
    Frequency: string;
    StpStartDate: string;
    NoOfInstallments: string;
    IsFirstOrderToday: boolean;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class SwpOrderVM {
    InvestorId: number;
    SchCode: number;
    BseSchemeToken: number;
    FolioNo: string;
    FolioTranMode: string;
    WithdrawIn: string;
    WithdrawValue: string;
    Frequency: string;
    SwpStartDate: string;
    NoOfInstallments: string;
    IsFirstOrderToday: boolean;
    BankAccountNo: string;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class SipVM {
    InvestorItemType: string;
    InvestorItemId: number;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class SipOM {
    Data: Sip[];
    constructor(obj: Sip[]) {
      this.Data = obj;
    }
  }

  export class Sip {
    ActiveSIP: number;
    TotalSIPAmt: number;
    CompletedSIP: number;
    CompletedSIPAmt: number;
    PendingSIP: number;
    PendingSIPAmt: number;
  }

  export class FundHoldingsVM {
    SchemeCode: number;
    FromDate: string;
    ToDate: string;
    RefKey: string;
  }

  export class FundHoldingsOM {
    SchemesTopHoldings: FundHoldings[];
    constructor(obj: any) {
      this.SchemesTopHoldings = obj.SchemesTopHoldings;
    }
  }

  export class FundHoldings {
    HoldingMonth: string;
    HoldingMonthText: string;
    InstrumentName: string;
    Industry: string;
    Nature: string;
    SubNature: string;
    ISIN: string;
    Quantity: number;
    MarketValue: number;
    NetAssetPer: number;
    MaturityDate: number;
    Duration: string;
    MaturityDateText: string;
  }

  export class SchemePortfolioSectorWiseVM {
    SchemeCode: number;
    RefKey: string;
  }

  export class SchemePortfolioSectorWiseOM {
    SchemePortfolioSectorWise: SchemePortfolioSectorWise[];
    constructor(obj: any) {
      this.SchemePortfolioSectorWise = obj.SchemePortfolioSectorWise;
    }
  }

  export class SchemePortfolioSectorWise {
    HoldingMonth: number;
    HoldingMonthText: string;
    Sector: string;
    MarketValue: number;
    NetAssetPer: number;
  }

  export class Invoke2FAVM {
    OrderID: number;
    TranType: string;
    HolderSeq: number;
    InvestorId: number;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class BMENACHFetchAuthURLVM {
    refKey: string;
    contextMenuCode: string;
    value1: string;
  }

  export class MakePaymentVM {
    OrderId: number;
    RefKey: string;
  }

  export class MakePaymentOM {
    Data: MakePaymentOM;
    constructor(obj: MakePaymentOM) {
      this.Data = obj;
    }
  }

  export class MakePayment {
    Data: string;
    ErrorCode: number;
    ConstantKey: null
    Message: string
  }

  export class RejectOrderVM {
    InvestorId: number;
    OrderID: number;
    TranType: string;
    Remark: string;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class SearchSchemeVM {
    SchemeName: string;
    RefKey: string;
  }

  export class SearchScehemeOM {
    Data: SearchScheme[];
    constructor(obj: SearchScheme[]) {
      this.Data = obj;
    }
  }

  export class SearchScheme {
    AMC: number;
    SchemeCode: string;
    SchCode: number;
    Name: string;
  }

  export class ApproveOrderVM {    
    OrderId: number;
    TranType: string;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class ApproveOrderOM {
    Data: ApproveOrder;
    constructor(obj: ApproveOrder) {
      this.Data = obj;
    }
  }

  export class ApproveOrder {
    GwsOrderId: number;
    Data: string;
    ErrorCode: number;
    Message: string;
  }

  export class InvestorListSearchVM {
    SearchType: string;
    SearchValue: string;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class InvestorListSearchOM {
    Data: ApproveOrder[];
    constructor(obj: ApproveOrder[]) {
      this.Data = obj;
    }
  }

  export class InvestorListSearch {
    InvestorId: number;
    InvestorName: string;
    InvestorCode: string;
    PAN: string;
    MaskPAN: string;
    Mobile: string;
    Email: string;
    HoldingPattern: string;
    IsMinor: boolean;
    TaxStatusId: number;
    TaxStatus: string;
    Dob: string;
    DobText: string;
    CreatedDate: string;
    CreationDateText: string;
    IsKyced: boolean;
    HasUCC: boolean;
    UccRequired: boolean;
    HasFatca: boolean;
    TiffFlag: boolean;
    SecondHolderName: string;
    SecondHolderPAN: string;
    ThirdHolderName: string;
    ThirdHolderPAN: string;
    UccRemark: string;
    FatcaRemark: string;
    TiffRemark: string;
    SubBrokerName: string;
    RmName: string;
    BranchName: string;
    ZoneName: string;
    RegionName: string;
  }

  export class stateListVM {
    refKey: string;
    countryId: number;
  }

  export class cityListVM {
    refKey: string;
    stateId: number;
  }

  export class auth2VM {
    Url: string;
    JsonBody: string;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class auth2OM {
    Data: auth2[];
    constructor(obj: any) {
      this.Data = obj.Data;
    }
  }

  export class auth2 {
    FiveYearChangeCAGR: number;
    OneMonthChangePer: number;
    OneWeekChangePer: number;
    OneYearChangePer: number;
    SchemeCode: number;
    SchemeName: string;
    SinceInception: number;
    SixMonthChangePer: number;
    ThreeMonthChangePer: number;
    ThreeYearChangeCAGR: number
  }

  export class schemePeriodicityVM {
    SchemeCode: number;
    Periodicity: string;
    RefKey: string;
  }

  export class scehemPeriodicityOM {
    Data: SchemePeriodicity[];
    constructor(obj: SchemePeriodicity[]) {
      this.Data = obj;
    }
  }

  export class SchemePeriodicity {
    Code: number;
    Name: string;
    Type: string;
    OneDay: number;
    OneWeek: number;
    TwoWeek: number;
    ThreeWeek: number;
    OneMonth: number;
    ThreeMonth: number;
    SixMonth: number;
    NineMonthReturn: number;
    OneYearReturn: number;
    TwoYearReturn: number;
    ThreeYearReturn: number;
    FiveYearReturn: number;
    ReturnSinceInception: number;
  }

  export class schemeSearchVM {
    TranMode: string;
    RefKey: string;
  }

  export class schemeSearchOM {
    Data: schemeSearch[];
    constructor(obj: schemeSearch[]) {
      this.Data = obj;
    }
  }

  export class schemeSearch {
    SchemeCode: string;
    SchemeName: string;
  }

  export class AUMReportTypesVM {
    RefKey: string;
  }

  export class AUMReportTypesOM {
    Data: AUMReportTypes[];
    constructor(obj: AUMReportTypes[]) {
      this.Data = obj;
    }
  }

  export class AUMReportTypes {
    text: string;
    id: string;
    d: boolean;
  }

  export class CollectionReportTypesVM {
    RefKey: string;
  }

  export class CollectionReportTypesOM {
    Data: CollectionReportTypes[];
    constructor(obj: CollectionReportTypes[]) {
      this.Data = obj;
    }
  }

  export class CollectionReportTypes {
    id: string;
    text: string;
  }

  export class AUMReportNCVM {
    ReportType: string;
    AsOnDate: string;
    ArnNumber: string;
    AmcId: number;
    SchCode: number;
    CategoryCode: number;
    RefKey: string;
  }

  export class AUMReportNCOM {
    Data: AUMReportNC;
    constructor(obj: AUMReportNC) {
      this.Data = obj;
    }
  }

  export class AUMReportNC {
    Table: AUMReportNCTable[];
    constructor(obj: AUMReportNCTable[]) {
      this.Table;
    }
  }

  export class AUMReportNCTable {
    CategoryCode: number;
    Category: string;
    Total_AUM: number;
    InvestorCode: number;
    Investor_Name: string;
    SubBrokerCode: null;
    SubBrokerName: null;
    EmpCode: string;
    EmployeeName: string;
    BranchCode: string;
    BranchName: string;
    ZoneCode: string;
    ZoneName: string;
    RegionCode: string;
    RegionName: string;
    Equity: number;
    Debt: number;
    Liquid: number;
    Other: number;
    AMCID: number;
    AMC_Name: string;
    Scheme_Name: string;
    Scheme_Class: string;
    InvGroupName: string;
    Folio_No: string;
    ProdCode: string;
    AMCName: string;
    InvGroupCode: number;
    Investor_Group_Name: string;
  }

  export class OrderDetailVM {
    ContextMenuCode: string;
    InvestorId: number;
    OrderId: number;
    TranType: string;
  }

  export class OrderDetailsOM {
    OrderData: OrderDetail[];
    constructor(obj: OrderDetail[]) {
      this.OrderData = obj;
    }
  }

  export class OrderDetail {
    InvestorID: number;
    InvestorCode: string;
    InvestorName: string;
    XRef1Type: null;
    XRef1Data: null;
    OrderID: number;
    AMCID: number;
    SchemeName: string;
    FolioNo: string;
    TranType: string;
    SubTranType: string;
    TranDate: string;
    TranDateText: string;
    Amount: number;
    Units: number | null;
    orderStatus: string;
    OrderStatusText: string;
    OrderStatusColor: string;
    BSESchCode: string;
    BseOrderStatusResponse: string;
    ChequeNumber: string;
    OrderPlacedBy: string;
    OrderPlacedDate: string;
    PaymentStatus: string;
    BSEPaymentStatus: string;
    BSEOrderNo: string;
    SubBrokerCode: string | null;
    SubBrokerName: string | null;
    EmpCode: string;
    EmployeeName: string;
    BranchCode: string;
    BranchName: string;
    ZoneCode: string;
    ZoneName: string;
    RegionCode: string;
    RegionName: string;
    TAR: number;
    TAC: number;
    Rate: null;
    SchCode: number;
    OrderPlacedByUserType: string;
    Mode: string;
    RedeemAll: string;
    BasketName: string | null;
    GoalName: string | null;
    LastNAV: number;
    OrderApprovedBy: string;
    Holder2PAN: string;
    Holder3PAN: string;
    Holder1_2FaFlag: boolean;
    Holder2_2FaFlag: boolean;
    Holder3_2FaFlag: boolean;
    TaxStatusID: number;
    RejectionDate: null;
    RefundStatus: null;
    RefundDate: null;
    RefundReference: null;
  }

  export class makePaymentVM {
    sessionKey: string;
  }

  export class AddBankAccountOBVM {
    refKey: string;
    investorId: number;
    bankId: number;
    bankName: string;
    accountTypeId: number;
    accountNumber: string;
    branchName: string;
    ifscCode: string;
    micrCode: string;
    nameAsPerBank: string;
  }

  export class SaveFormFatcaIndividualVM {
    refKey: string;
    investorId: number;
    panNumber: string;
    lastSavedKycForm: string;
    fatcaCountryId: number;
    fatcaCity: string;
    incomeSlabId: number;
    occupationId: string;
    sourceOfWealthId: number;
    pepStatusId: string;
    fatcaOtherInfo: string;
  }

  export class SaveFormOtherDetailsVM {
    refKey: string;
    investorId: number;
    panNumber: string;
    lastSavedKycForm: string;
    riskProfileId: number;
    aadharUpdatedFlag: string;
    pmsFlag: string;
    cmbpId: string;
    nomineeSOA: boolean;
  }

  export class FAQListVM {
    refKey: string;
    categoryUQID: string;
  }
  
  export class NomineeSaveVM {
    refKey: string;
    nomineeName: string;
    relationId: number;
    relationText: string;
    nomineeDob: string;
    nomineeTypeId: string;
    nomineeGuardian: string;
    nomineeGuardianPAN: string;
    address1: string;
    address2: string;
    address3: string;
    countryId: number;
    stateId: number;
    cityId: number;
    city: string;
    pinCode: string;
    email: string;
    mobile: string;
    idProofTypeLKID: string;
    idProofNum: string;
    nomineeId: number;
    investorId: number;
    sharingPerc: number;
  }

  export class authNomineeSendOTPVM {
    refKey: string;
    investorId: number;
  }

  export class authNomineeVerifyOTPVM {
    refKey: string;
    investorId: number;
    holderSeq: number;
    otpKey: string;
    otpValue: string;
  }

  export class InvestorInfoVM {
    refKey: string;
    investorId: number;
  }

  export class BankListByIFSCCodeVM {
    refKey: string;
    ifscCode: string;
  }

  export class BankListByIFSCCodeOM {
    Data: BankListByIFSCCode[];
    constructor(obj: BankListByIFSCCode[]) {
      this.Data = obj;
    }
  }
  export class BankListByIFSCCode {
    id: number;
    ifscCode: string;
    micrCode: string;
    branch: string;
    City: string;
    State: string;
    BankID: number;
    BankName: string;
    ENachAllowed: null;
  }

  export class InvestorCreateNewVM {
  refKey?: string;
  taxStatusId: number;
  panNumber: string;
  mobile: string;
  isMobileVerified: boolean;
  email: string;
  investorDob: string;
  guardianDob?: string;
  investorName?: string;
  fullDpId?: string;
  dpCode?: string;
  mapTo?: {
    type?: string;
    id?: number | null;
    code?: string;
  };
  xRef1Type?: string;
  xRef1Data?: string;
  bankAccountNo?: string;
  holder1MobileBelongsTo?: string;
  holder1EmailBelongsTo?: string;
}
  export class CreateInvestorV1VM {
    refKey: string;
    taxStatusId: number;
    panNumber: string;
    investorCode: string;
    investorName: string;
    investorFirstName: string;
    investorMiddleName: string;
    investorLastName: string;
    loginName: string;
    uccFlag: boolean;
    panKycFlag: boolean;
    fatcaFlag: boolean;
    tiffFlag: boolean;
    dob: string;
    guardianName: string;
    guardianFirstName: string;
    guardianMiddleName: string;
    guardianLastName: string;
    guardianDob: string;
    guardianRelationshipId: number;
    mobile: string;
    email: string;
    holder1MobileBelongsTo: string;
    holder1EmailBelongsTo: string;
    gender: string;
    occupationId: number;
    address1: string;
    address2: string;
    address3: string;
    cityId: number;
    cityName: string;
    stateId: number;
    countryId: number;
    pinCode: string;
    bankId: number;
    accountNumber: string;
    ifscCode: string;
    micrCode: string;
    accountTypeId: number;
    nominee1: {
      refKey: string;
      nomineeName: string;
      relationId: number;
      relationText: string;
      nomineeTypeId: string;
      nomineeDob: string;
      nomineeGuardian: string;
      nomineeGuardianPAN: string;
      address1: string;
      address2: string;
      address3: string;
      countryId: number;
      stateId: number;
      cityId: number;
      city: string;
      pinCode: string;
      email: string;
      mobile: string;
      idProofTypeLKID: string;
      idProofNum: string;
    }
    fatcaCountryId: number;
    sourceOfWealthId: number;
    incomeSlabId: number;
    netWorthIncome: number;
    pepStatusId: string;
    riskProfileId: number;
    kycMode: string;
    mapToSubBrokerId: number;
    mapToRmId: number;
    mfTranModeId: string;
    depositoryId: string;
    nsdlDpId: string;
    nsdlAccNo: string;
    cdslAccNo: string;
    benfAccNo: string;
  }

  export class CreateInvestorV1OM {
    Data: CreateInvestorV1[];
    constructor(obj: CreateInvestorV1[]) {
      this.Data = obj;
    }
  }
  export class CreateInvestorV1 {
    InvestorId: number;
    InvestorCode: string;
    LoginName: string;
    AccountId: number;
    ClientId: number;
  }

  export class MFOrderRecheckPaymentStatus {
    refKey: string;
    gwsOrderId: number;
    tranType: string;
  }
  export class MFOrderDetail {
    refKey: string;
    investorId: number;
    gwsOrderId: number;
    tranType: string;
    includeDisplayData: boolean;
  }

  export class SIPAllocationReportVM {
    refKey: string;
    fromDate: string;
    toDate: string;
    reportWise: string;
  }

  export class SIPAllocationReportOM {
    Data: SIPAllocationReport[];
    constructor(obj: SIPAllocationReport[]) {
      this.Data = obj;
    }
  }

  export class SIPAllocationReport {
    AMC_Name: string;
    No_Of_SIP: number;
    Total_Amount: number;
    Scheme_Name: string;
    Investor_Name: string;
    Employee_Name: string;
    SubBroker_Name: string;
    Branch_Name: string;
    Zone_Name: string;
    Region_Name: string;
  }
  export class CollectionReportNCVM {
    ReportType: string;
    arnNumber: string;
    AmcId: number;
    SchCode: number;
    CategoryCode: number;
    FromDate: string;
    ToDate: string;
    RefKey: string;
  }

  export class CollectionReportNCOM {
    Data: CollectionReportNC[];
    constructor(obj: CollectionReportNC[]) {
      this.Data = obj;
    }
  }

  export class CollectionReportNC {
    Category: string;
    Purchase_Count: number;
    Purchase_Amount: number;
    Redemption_Count: number;
    Redemption_Amount: number;
    Net_Count: number;
    Net_Amount: number;
    Region_Code: string;
    Region_Name: string;
    Zone_Code: string;
    Zone_Name: string;
    BranchCode: string;
    Branch_Name: string;
    EmpCode: string;
    Employee_Name: string;
    SubBrokerCode: null;
    SubBroker_Name: string;
    Investor_Name: string;
    PAN: string;
    AMC_Name: string;
    Scheme_Name: string;
    Sub_Category: string;
    Investor_Code: string;
    InvGroupName: string;
    InvGroupCode: number;
  }

  export class ForgotPasswordSentOTPVM {
    LoginName: string;
    RefKey: string;
  }

  export class ForgotPasswordResetByOTPVM {
    LoginName: string;
    OtpKey: string;
    OtpValue: string;
    RefKey: string;
  }

  export class ForgotPasswordResendOTPVM {
    OtpKey: string;
    RefKey: string;
  }

  export class ValidateUserDetailsForMobileOTPVM {
    ScreenCode: string;
    MobileNumber: string;
    UserType: number;
    UserCode: string;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class ValidateMobileOTPForLoginVM {
    OtpKey: string;
    OtpValue: string;
    AccCode: string;
    RefKey: string;
    ContextMenuCode: string;
  }

  export class ValidateUserDetailsForMobileOTPOBVM {
    refKey: string;
    screenCode: string;
    mobileNumber: string;
    mobileEnc: string;
    userType: number;
    userCode: string;
  }
}


// export class PortfolioRecordsInvestorFundDetailsVM {
//   Data:PortfolioRecordsInvestorFundDetailsData;
//   constructor(obj:any){
//     this.Data = obj;
//   }
// }

// // export class PortfolioRecordsInvestorFundDetailsData {
// //   AbsRetn:number;
// //   AnnualizedRetn:number;
// //   AvgCost:number;
// //   BUnits:number;
// //   BenchmarkReturn:number;
// //   Category:string;
// //   CurrentNAV:number;
// //   CurrentValue:number;
// //   DPID:string;
// //   DivFlag:string;
// //   DivPayout:number;
// //   FolioNo:string;
// //   GoalID:string;
// //   GoalName:string;
// //   GrossAmount:number;
// //   InvCode:string;
// //   InvestedAmount:number;
// //   InvestorCode:string;
// //   InvestorID:number;
// //   InvestorName:string;
// //   NAVDate:string;
// //   NAVDateText:string;
// //   Nature:string;
// //   NotionalPL:number;
// //   SchCode:number;
// //   SchemeName:string;
// //   StampDuty:number;
// //   SubNature:string;
// //   TaxStatus:string;
// //   Weightage:number;
// //   XIRR:number;
// //   Text:string;
// //   Id:string;
// //   style:InvestorFundDetailsStyle;
// // }

// // // export interface stylesss{
// // //   styless:"me"|"we";
// // // }

export enum InvestorFundDetailsStyle {
  StyleCurrency = "CURRENCY", //amount
  StyleSign = "SIGN", //vector
  StyleCurrencyColor = "CURRENCYCOLOR", //amount color
  StyleSignColor = "SIGNCOLOR", //vector color
  StyleNoSign = 'NOSIGN',
  StyleNoSignColor = 'NOSIGNCOLOR',
  StyleText = 'TEXT'
}
// // // type Roles = "admin" | "owner" | "user";

// // export interface PortfolioRecordsInvestorFundDetailsVMs {
// //   Data:string;
// //   Value:number;
// //   style:InvestorFundDetailsStyle
// // }